// Query keys for data fetching
export const WORKFLOW_QUERY_KEYS = {
  getAllWorkflows: 'ai-workflow-get-all',
  getTriggers: 'ai-workflow-get-triggers',
  getActions: 'ai-workflow-get-actions',
  getWorkflowById: 'ai-workflow-get-by-id',
  getExecutions: 'ai-workflow-get-executions',
  getStatistics: 'ai-workflow-get-statistics',
};

// Decision prompt suggestions for AI decision step
export const DECISION_PROMPT_SUGGESTIONS = [
  'If reimbursement is of type Travel, auto approve',
  'Approve Leave request for everyone except Apurva',
  'If the amount is more than 10000, reject it',
];

// Action type constants
export const ACTION_TYPES = {
  AI_DECISION: 'ai_decision',
  APPROVE_OR_REJECT: 'approve_or_reject',
  SEND_EMAIL: 'send_email',
  CALL_API: 'call_api',
} as const;

// Trigger scope options for display
export const TRIGGER_SCOPE_OPTIONS = [
  { value: 'all_users', label: 'All Users' },
  { value: 'all_reportees', label: 'All Reportees' },
  { value: 'specific', label: 'Specific Employees' },
];

// HTTP methods for Call API action
export const HTTP_METHODS = ['GET', 'POST', 'PUT', 'DELETE'] as const;

// Activity log filter options
export const STATUS_OPTIONS = [
  { label: 'All statuses', value: '' },
  { label: 'Completed', value: 'completed' },
  { label: 'Running', value: 'running' },
  { label: 'Pending', value: 'pending' },
  { label: 'Failed', value: 'failed' },
];

export const ENTITY_TYPE_OPTIONS = [
  { label: 'All types', value: '' },
  { label: 'Reimbursement', value: 'reimbursement' },
  { label: 'Leave', value: 'leave' },
  { label: 'Expense', value: 'expense' },
];

export const DAYS_OPTIONS = [
  { label: 'Last 7 days', value: '7' },
  { label: 'Last 30 days', value: '30' },
  { label: 'Last 90 days', value: '90' },
];

// Trigger icons mapping
export const TRIGGER_ICONS: Record<string, string> = {
  reimbursement_created: '💰',
  leave_created: '📅',
};

// Action icons mapping
export const ACTION_ICONS: Record<string, string> = {
  approve_or_reject: '✅',
  send_email: '📧',
  call_api: '🌐',
};

// Supported placeholders for email and API actions
export const SUPPORTED_PLACEHOLDERS = {
  ai_decision: [
    { placeholder: '{{decision}}', description: 'AI decision (approved/rejected/needs_review)' },
    { placeholder: '{{reason}}', description: 'AI reasoning for the decision' },
    { placeholder: '{{confidence}}', description: 'Confidence level (HIGH/MEDIUM/LOW)' },
  ],
  employee: [
    { placeholder: '{{employee_name}}', description: 'Name of the employee' },
    { placeholder: '{{employee_id}}', description: 'Employee ID' },
    { placeholder: '{{department}}', description: 'Employee department' },
    { placeholder: '{{designation}}', description: 'Employee designation' },
  ],
  reimbursement: [
    { placeholder: '{{amount}}', description: 'Reimbursement amount' },
    { placeholder: '{{type}}', description: 'Type of reimbursement' },
    { placeholder: '{{expense_date}}', description: 'Date of expense' },
    { placeholder: '{{reimbursement_reason}}', description: 'Reason for reimbursement' },
  ],
  leave: [
    { placeholder: '{{total_days}}', description: 'Total days requested' },
    { placeholder: '{{date_from}}', description: 'Leave start date' },
    { placeholder: '{{date_to}}', description: 'Leave end date' },
    { placeholder: '{{leave_balance}}', description: 'Leave balance before request' },
  ],
  workflow: [
    { placeholder: '{{workflow_id}}', description: 'Workflow ID (API only)' },
    { placeholder: '{{execution_id}}', description: 'Execution ID (API only)' },
    { placeholder: '{{organization_id}}', description: 'Organization ID (API only)' },
  ],
};
